<template>
    <div class="ip-forbid" @keyup.enter="goBack">
        <div class="center-box">
            <div class="title-area">
                <span class="title-text">IP认证失败，拒绝访问</span>
            </div>
            <div class="center-area">
                <i class="el-icon-warning"  style="color:red; font-size: 40px;"></i>
                <span style="margin-left: 20px;font-size:18px;">{{$store.state.loginError}}</span>
            </div>
            <div class="bottom-area">
                <el-button type="primary" size="small" @click="goBack" style="width: 120px;margin-right: 50px;">确定</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "IpForbidden",
        methods: {
            goBack() {
                window.history.back()
            }
        }
    }
</script>

<style scoped>
    .ip-forbid {
        width: 100vw;
        height: 100vh;
        /*min-height: 700px;*/
        background: #f1f0f3;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }
    .center-box{
        width: 700px;
        height: 420px;
        background: white;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        border: 1px solid darkgray;
    }
    .title-area {
        position: relative;
        width: 100%;
        height: 60px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-bottom: 1px solid darkgray;
    }
    .title-text {
        font-size: 20px;
        font-weight: bold;
    }
    .center-area{
        width: 100%;
        height: 300px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }
    .bottom-area {
        width: 100%;
        height:40px;
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        justify-content: flex-end;
    }
</style>